export default __webpack_public_path__ + "static/sales 1-151bbdbec50c9bc44a602cbeb135171b.png";